
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    {
      /* KEYWORDS: peerassets */
    }
    <h1>{`PeerAssets`}</h1>
    <blockquote>
      <p parentName="blockquote">{`PeerAssets offers the framework that enables communities and organizations to issue and transact with blockchain assets.`}</p>
    </blockquote>
    <p>{`PeerAssets is a blockchain token protocol invented in 2016 by `}<inlineCode parentName="p">{`peerchemist`}</inlineCode>{` as a minimalist method to efficiently support tokenization. PeerAssets is tailored to work with the Peercoin blockchain, however its design is general and can be ported to other blockchains like Bitcoin with cross-chain compatibility.
PeerAssets transactions are standard Peercoin transactions, relayed by the standard nodes and processed by miners as any other transaction. Unlike many similar protocols (`}<a parentName="p" {...{
        "href": "http://www.omnilayer.org/"
      }}>{`Omni`}</a>{`, `}<a parentName="p" {...{
        "href": "http://counterparty.io/"
      }}>{`CounterParty`}</a>{`), PeerAssets does not use so called "auxilary" tokens (Omni and XCP respectively), it only uses blockchain's native currency which is used to pay transaction fees. PeerAssets protocol does not require hard nor soft fork of the host network, but it requires development of a PeerAssets aware client. PeerAssets is also inspired by the original idea of "Colored Coins" and uses OP_RETURN to write data on the blockchain, but offers some optimizations to reduce amount of data written in the OP_RETURN and reducing blockchain bloat.
PeerAssets enables easy querying of the blockchain for relevant transactions via the use P2TH, which allows development of very light clients and does not mandate the use of resource intense blockchain-parsing nodes which are common with competing protocols.`}</p>
    <p>{`PeerAsset tokens can be utilized to represent any type of asset like bonds or equity. PeerAssets can also represent real life objects in the form of non-fungible tokens, and allow for authentification via the blockchain. The possibilities are wide enough to encompass most use cases for tokenization, without sacrificing the efficiency of the design.`}</p>
    <h3>{`Nomenclature`}</h3>
    <p>{`PeerAssets uses a friendly phrasing to succinctly describe the protocol and it's interactions. In PeerAssets terminology assets are named “decks” and each transaction on the deck is called a “card”. Deck creation and card manipulation are types of transactions parsed by the PeerAsset client, which uses the known protocol rules to calculate card balances and the total state of the deck. A deck with a single card, for example, would act as a non-fungible token.`}</p>
    <p><inlineCode parentName="p">{`Deck - named asset`}</inlineCode></p>
    <p><inlineCode parentName="p">{`Card - individual token`}</inlineCode></p>
    <h2>{`Transaction types`}</h2>
    <p>{`PeerAssets protocol has four elemental transaction types:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Deck spawning transaction`}</strong></li>
    </ul>
    <p>{`Creates a new token at a given Peercoin address. Asset is described by:`}</p>
    <ul>
      <li parentName="ul">{`token name,`}</li>
      <li parentName="ul">{`descriptive metadata,`}</li>
      <li parentName="ul">{`how divisible the token is (number of decimals),`}</li>
      <li parentName="ul">{`the deck issue mode.`}</li>
    </ul>
    <p>{`Deck issue modes can be understood as light smart contracts as they allow great flexibility when defining common rules of token economics such as ONCE, MULTI, or CUSTOM.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Card issue transaction`}</strong></li>
    </ul>
    <p>{`Creates new tokens of `}<inlineCode parentName="p">{`deck`}</inlineCode>{` at given Peercoin address.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Card burn transaction`}</strong></li>
    </ul>
    <p>{`Destroys tokens and removes them from the supply.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Card transfer transaction`}</strong></li>
    </ul>
    <p>{`Standard p2p token transaction, transfer a token from the address where they reside to a new address.`}</p>
    <h2>{`Tools`}</h2>
    <h3>{`pacli`}</h3>
    <p>{`This command line program is useful as companion utility during PeerAssets development and testing. It is built for console usage via intuitive and easy to learn set of commands. It stores the privkey in OS's native keystore, which is automatically unlocked upon logging into active user session.`}</p>
    <p>{`github: `}<a parentName="p" {...{
        "href": "https://github.com/PeerAssets/pacli"
      }}>{`https://github.com/PeerAssets/pacli`}</a></p>
    <h3>{`pypeerassets`}</h3>
    <p>{`Official Python implementation of the PeerAssets protocol.`}</p>
    <p>{`github: `}<a parentName="p" {...{
        "href": "https://github.com/PeerAssets/pypeerassets"
      }}>{`https://github.com/PeerAssets/pypeerassets`}</a></p>
    <h3>{`papi`}</h3>
    <p>{`PeerAssets API provider, implemented using pypeerassets.`}</p>
    <p>{`github: `}<a parentName="p" {...{
        "href": "https://github.com/PeerAssets/papi"
      }}>{`https://github.com/PeerAssets/papi`}</a></p>
    <h2>{`Wallets`}</h2>
    <h3>{`chizukeki`}</h3>
    <p>{`A light, cross-platform Peercoin wallet with baked-in support for the PeerAssets.`}</p>
    <p>{`code: `}<a parentName="p" {...{
        "href": "https://github.com/peerassets/chizukeki"
      }}>{`https://github.com/peerassets/chizukeki`}</a></p>
    <p>{`deployed: `}<a parentName="p" {...{
        "href": "https://peerassets.github.io/chizukeki/"
      }}>{`https://peerassets.github.io/chizukeki/`}</a></p>
    <h2>{`Future plans & research`}</h2>
    <p>{`The PeerAssets project has adopted `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Request_for_Comments"
      }}>{`RFC`}</a>{` schema of sharing new ideas and establishing standards like the Peercoin project.
RFC's are submitted on the PeerAssets `}<a parentName="p" {...{
        "href": "https://github.com/PeerAssets/peerassets-rfcs"
      }}>{`github repo`}</a>{` and peer-reviewed, after which code experimentation and final implementation proceeds.`}</p>
    <p>{`Some RFCs that show the wide array of possible applications for PeerAssets includes:`}</p>
    <p><a parentName="p" {...{
        "href": "https://github.com/PeerAssets/peerassets-rfcs/blob/master/0003-peerassets-alias-poid-protocol-specification.md"
      }}>{`PeerAssets Alias/Proof-of-identity protocol specification`}</a></p>
    <blockquote>
      <p parentName="blockquote">{`Extension of PeerAssets protocol specifies using singlet PeerAsset deck to alias the Peercoin address with any UTF-8 string with added secondary functionality of using descriptive information contained in the PeerAssets token to allow proof-of-identity verification of the privkey owner.`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "https://github.com/PeerAssets/peerassets-rfcs/blob/master/0005-on-chain-voting-protocol-proposal.md"
      }}>{`PeerAssets on-chain voting protocol specification`}</a></p>
    <blockquote>
      <p parentName="blockquote">{`PeerAssets on-chain voting protocol. Aim is to deliver a standardized way to organize and operate peer-to-peer voting and opinion polls in fully decentralized and trustless fashion. Both vote and poll initialization and counting must be done in completely decentralized and trustless fashion without dependency on 3rd party services.`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "https://github.com/PeerAssets/peerassets-rfcs/blob/master/0009-data-audit.md"
      }}>{`PeerAssets Data Audit Protocol`}</a></p>
    <blockquote>
      <p parentName="blockquote">{`The primary purpose of this protocol is to record cryptographic hashes of successive revisions of single-file documents in a public blockchain, in a manner which enables thin clients to easily query and verify document histories. Such histories inherit useful properties from the underlying blockchain, namely immutability and massive replication, and can therefore serve as proofs of existence.`}</p>
    </blockquote>
    <h2>{`Articles`}</h2>
    <p><a parentName="p" {...{
        "href": "http://peerassets.github.io/WhitePaper/"
      }}>{`Whitepaper`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://medium.com/peercoin/peerassets-deck-issue-modes-c419f38f7800"
      }}>{`PeerAssets deck issue modes`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://medium.com/peercoin/the-benefits-of-peerassets-77bad7693925"
      }}>{`The benefits of PeerAssets`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://talk.peercoin.net/t/tutorial-peerassets-peer-to-peer-p2p-transactions/8640"
      }}>{`[Tutorial] PeerAssets Peer to Peer (p2p) Transactions`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://talk.peercoin.net/t/tutorial-basic-deck-creation-with-peerassets/8639"
      }}>{`[Tutorial] Basic Deck Creation with PeerAssets`}</a></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;